import { render } from "./Intranet.vue?vue&type=template&id=bd9ddb00"
import script from "./Intranet.vue?vue&type=script&lang=js"
export * from "./Intranet.vue?vue&type=script&lang=js"

import "./Intranet.vue?vue&type=style&index=0&id=bd9ddb00&lang=css"

import exportComponent from "/Users/alexis/Desktop/Software/grupo_albarran_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__